import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDTitleText,
} from '@facet-wealth/design';
import { MediaRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/MediaRel';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextMedium, TitleTextLarge } from 'Packages/FacetDesign/Components';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { dataAttrs } from 'Helpers/Testing';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => TitleTextLarge,
  }, overrideReadOnly)
  .override({ name: 'title', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { Component: FDTitleText, size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly)
  .override({ name: 'subtitle', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { Component: FDBodyText, size: 'md' },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly)
  .override({ name: 'description', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { Component: FDBodyText, size: 'md' },
  }, overrideReadOnly);

const useStyles = buildUseStyles('StructuredContentFeature', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(1)}px`,
    alignItems: 'flex-start',
    flex: 1,
    flexBasis: 300,
    '& img': {
      width: 'auto !important',
      borderRadius: '0px !important',
    },
  },
}));

export const Feature = ({ structuredContentResource }) => {
  const classes = useStyles();
  return (
    <div
      className={classes.root}
      {...dataAttrs('structured-content-feature', structuredContentResource)}
    >
      <MediaRel
        relationship={structuredContentResource.relationship(fr.relationships.media.name)}
        height={60}
        {...dataAttrs('structured-content-feature-media', structuredContentResource)}
      />
      <MetaControl
        resource={structuredContentResource}
        attrName={'title'}
        metaOverrideSet={metaOverrideSet}
        CustomProps={{
          ...dataAttrs('structured-content-feature-title', structuredContentResource),
        }}
      />
      <MetaControl
        resource={structuredContentResource}
        attrName={'subtitle'}
        metaOverrideSet={metaOverrideSet}
        CustomProps={{
          ...dataAttrs('structured-content-feature-subtitle', structuredContentResource),
        }}
      />
      <MetaControl
        resource={structuredContentResource}
        attrName={'description'}
        metaOverrideSet={metaOverrideSet}
        CustomProps={{
          ...dataAttrs('feature-description', structuredContentResource),
        }}
      />
    </div>
  );
};

Feature.propTypes = {
  structuredContentResource: PropTypes.object.isRequired,
};
